export default "__VITE_ASSET__2531dbc4__"